import { formatInTimeZone } from 'date-fns-tz'
import { useAuthStore } from '@/store/auth-store'
import { useGetUserInfo } from '../api/useGetUserInfo'
import { useDateStore } from '@/components/DateInput'

export const NIGHT_SHIFT_END_HOUR = 5

export const useNightShiftInfo = () => {
    const { date } = useDateStore()
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const { data: userInfo } = useGetUserInfo()
    const { startOfShiftTime, endOfShiftTime } = useAuthStore()

    const isNightShift = userInfo?.lastSessionDetails?.isNightShift ?? false

    const startShiftDate = startOfShiftTime
        ? formatInTimeZone(startOfShiftTime, timezone, "yyyy-MM-dd'T'HH:mm:ss")
        : null

    const isAfterMidnight = (): boolean => {
        const appDay = new Date(date)
        const now = new Date()
        const isPreviousDay = appDay.getDate() === now.getDate() - 1
        return isPreviousDay && now.getHours() < NIGHT_SHIFT_END_HOUR
    }

    return { isNightShift, startShiftDate, isAfterMidnight, endOfShiftTime }
}
